import styled from 'styled-components'
import { BLUE_PRINCIPAL, GREEN, GREY_DARK, GREY_LIGHTS_2, WHITE } from '../../utils/colors'

export const Container = styled.div`
  padding: 40px 0px;
  padding-bottom: 0px;
  overflow: hidden;
  margin: 80px 6px;
  max-width: 297px;
  border-radius: 8px;
  border: solid 1px ${GREEN};
  background-color: ${WHITE};

  @media print {
    max-width: 100%;
    border: none;
    overflow: initial;
  }

  .flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 26px;
    font-size: 12px;
    border-bottom: 1px solid ${GREY_LIGHTS_2};
    color: ${GREY_DARK};
    page-break-inside: avoid;
  }

  h3 {
    font-size: 24px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
    color: ${GREEN};
    margin-bottom: 26px;
    text-align: center;
  }

  .total {
    text-align: center;
    min-height: 78.1px;
    font-size: 40px;
    font-weight: bold;
    color: ${BLUE_PRINCIPAL};
  }

  span {
    display: block;
  }

  .label {
    flex: 1;
    margin-right: 10px;
    overflow: hidden;
    text-overflow: ellipsis;

    button {
      display: inline-block;
      border: none;
      background: transparent;
      text-decoration: underline;
      color: ${GREY_DARK};
      font-family: inherit;
      padding: 0;
      cursor: pointer;
    }
  }

  .text {
    white-space: nowrap;
    text-align: right;
    font-weight: bold;
  }
`
